import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadVehicleRegistryStatusHistorySuccessful,
  loadVehicleRegistryStatusHistoryFailed,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition, { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadVehicleRegistryStatusHistory(action) {
  try {
    const { payload = {} } = action;
    const {
      filter,
    } = payload;
    let pool = {
      include: 'applicants,files,registryVehicle',
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }

    const url = `${BACKEND_URL_V2}/dict/vehicles/all`;

    const response = yield makeRequest(url, pool, action, 'GET', true);
    const responseData = yield response.json();
    if (response.status === OK) {
      yield put(loadVehicleRegistryStatusHistorySuccessful(responseData));
      yield call(resolveActionPromise(action, responseData));
    } else {
      yield put(loadVehicleRegistryStatusHistoryFailed());
      yield call(rejectActionPromise(action, responseData));
    }
  } catch (e) {
    yield put(loadVehicleRegistryStatusHistoryFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
